function closeCompatibilityAccordionTrigger(trigger) {
  trigger.setAttribute('aria-expanded', 'false');
  const expandRow = trigger.closest('tr')?.nextElementSibling;
  if (expandRow?.classList.contains('compatibility-table__expand-row')) {
    expandRow.hidden = true;
  }
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-compatibility-accordion-trigger]');
  if (!trigger) return;

  const container = trigger.closest('.compatibility-table-wrapper');
  const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

  if (container) {
    container.querySelectorAll('[data-compatibility-accordion-trigger]').forEach((otherTrigger) => {
      if (otherTrigger === trigger) return;
      closeCompatibilityAccordionTrigger(otherTrigger);
    });

    container.querySelectorAll('details.compatibility-table__products-accordion').forEach((details) => {
      if (details.contains(trigger)) return;
      details.removeAttribute('open');
    });
  }

  trigger.setAttribute('aria-expanded', String(!isExpanded));

  const expandRow = trigger.closest('tr')?.nextElementSibling;
  if (expandRow?.classList.contains('compatibility-table__expand-row')) {
    expandRow.hidden = isExpanded;
  }
});

document.addEventListener('toggle', (event) => {
  const details = event.target;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.classList.contains('compatibility-table__products-accordion')) return;
  if (!details.open) return;

  const container = details.closest('.compatibility-table-wrapper');
  if (!container) return;

  container.querySelectorAll('details.compatibility-table__products-accordion').forEach((other) => {
    if (other !== details) other.removeAttribute('open');
  });

  container.querySelectorAll('[data-compatibility-accordion-trigger]').forEach((trigger) => {
    closeCompatibilityAccordionTrigger(trigger);
  });
});
